import './App.css';
import Dictionary from './Dictionary';

export default function App() {
  return (
    <div className="App">
      <div className='container'>
      <header className="App-header">
      </header>
      <main>
        <Dictionary />
      </main>
      <footer className="app-footer">
        Coded by Lottie Aldridge <a href="https://github.com/lottiealdridge/dictionary-app" target='_blank'rel="noreferrer">open sourced via Github</a>
      </footer>
      </div>
    </div>
  );
}


